import { SidebarTrigger } from "@/components/ui/sidebar";
import { Separator } from "@/components/ui/separator";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";
interface PortfolioHeaderProps {
  portfolioName?: string;
  portfolioType?: string;
}

const getDisplayText = (type: string) => {
  switch (type) {
    case 'model':
      return 'Model Portfolio';
    case 'personal':
      return 'Personal Portfolio';
    case 'client':
      return 'Client Portfolio';
    default:
      return 'Model Portfolio';
  }
};

const getVariant = (type: string) => {
  switch (type) {
    case 'model':
      return 'default';
    case 'personal':
      return 'secondary';
    case 'client':
      return 'outline';
    default:
      return 'default';
  }
};

export const PortfolioHeader = ({ portfolioName, portfolioType }: PortfolioHeaderProps) => {
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4 sticky top-0 bg-background z-10">
      <SidebarTrigger className="-ml-2" />
      <Separator orientation="vertical" className="h-6" />
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/">Dashboard</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <ChevronRight className="h-4 w-4" />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbLink asChild>
              <Link to="/portfolios">Portfolios</Link>
            </BreadcrumbLink>
          </BreadcrumbItem>
          <BreadcrumbSeparator>
            <ChevronRight className="h-4 w-4" />
          </BreadcrumbSeparator>
          <BreadcrumbItem>
            <BreadcrumbPage>{portfolioName || 'Build Portfolio'}</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>
      {portfolioType && (
        <div className="ml-auto">
          <Badge variant={getVariant(portfolioType)} className="ml-auto whitespace-nowrap">
            {getDisplayText(portfolioType)}
          </Badge>
        </div>
      )}
    </header>
  );
};
